import { SelectOption } from '../model/select-option';
import optionsLabels from '../../assets/options.json';
import { Options } from '../model/options';

export class SelectUtils {
  public static valuesFromGymTypesOptions(
    gymTypes: Options['gymTypes']
  ): SelectOption[] {
    return Object.values(gymTypes)
      .map((v: string) => ({
        key: v,
        value: (optionsLabels.gymTypes as { [key: string]: string })[v] || v,
      }))
      .sort((a: SelectOption, b: SelectOption) =>
        a.value.localeCompare(b.value)
      );
  }
}
